<template>
  <div class="customer-invoices">
    <BaseTable
      :is-loading="isLoading"
      :items="invoices"
      :fields="tableFields"
      :is-searchable="false"
      :clickable="true"
      @row-selected="onRowSelected"
    >
      <template #status-data="{ row }">
        <BaseBadge v-if="row.status === INVOICE_STATUS.OVERDUE" variant="error" class="capitalize">
          {{ row.status }}
        </BaseBadge>
        <BaseBadge v-else-if="row.status === INVOICE_STATUS.PAID" variant="success" class="capitalize">
          {{ row.status }}
        </BaseBadge>
        <BaseBadge v-else-if="row.status === INVOICE_STATUS.OUTSTANDING" variant="warning" class="capitalize">
          {{ row.status }}
        </BaseBadge>
      </template>
      <template #invoiceDate-data="{ row }">
        {{ new Date(row.invoiceDate).toLocaleDateString() }}
      </template>
      <template #dueDate-data="{ row }">
        {{ new Date(row.dueDate).toLocaleDateString() }}
      </template>
      <template #total-data="{ row }">
        ${{ row.total.toFixed(2) }}
      </template>
      <template #balance-data="{ row }">
        ${{ row.balance.toFixed(2) }}
      </template>
    </BaseTable>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { httpsCallable } from 'firebase/functions'
import { Invoice } from '@/models/invoice'
import FirebaseService from '@/services/FirebaseService'
import BaseTable from '@/components/base/BaseTable.vue'
import BaseBadge from '@/components/base/BaseBadge.vue'
import { INVOICE_STATUS } from '@/models/invoice'

const route = useRoute()
const router = useRouter()
const customerId = computed(() => route.params.customerId)

const tableFields = [
  { key: 'invoiceId', label: 'Invoice #', sortable: false },
  { key: 'status', label: 'Status', sortable: false },
  { key: 'dueDate', label: 'Due Date', sortable: true },
  { key: 'total', label: 'Total', sortable: false },
  { key: 'balance', label: 'Balance', sortable: false }
]

const invoices = ref<Invoice[]>([])
const isLoading = ref(false)

const fetchInvoices = async () => {
  const functions = await FirebaseService.functions()
  const fetchInvoices = httpsCallable(functions, 'invoice-fetchAllInvoicesForCustomer')
  isLoading.value = true
  const result = await fetchInvoices({ customerId: customerId.value })
  invoices.value = result.data as Invoice[]
  isLoading.value = false
}

const onRowSelected = (invoice: Invoice) => {
  router.push({ name: 'ViewInvoice', params: { id: invoice.id } })
}

onMounted(async () => {
  await fetchInvoices()
})
</script>